import React from "react";
import "./index.scss";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import Title from "features/components/title";
import {__} from "services/i18n";
import Button from "features/components/button";
import {historyObject} from "historyObject";
import {Tabber, TabberChild} from "features/components/tabber";
import SettingsAccount from "features/pages/settings/account";
import SettingsPayment from "features/pages/settings/payment";
import {connect} from "react-redux";
import {getProfileStart} from "store/reducer/user/profile/reducer";
import SettingsEmail from "features/pages/settings/email_settings";

/* istanbul ignore next */
const mapStateToProps = state => ({

});
/* istanbul ignore next */
const mapDispatchToProps = {
    getProfileStart
};

export const AccountSettingsPage = (props) => {
    const {getProfileStart} = props;
    React.useEffect(() => {
        getProfileStart();
    }, [getProfileStart])
    return <LoggedInLayout
        type={"light"}
        className={"account-settings-page"}
        breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "common.personal-area"}, {title: "settings.breadcrumb"}, {title: "..."}]}>
        <div className={"sidebar-wrapper"}>
            <div className="sidebar">
                <Title size={34}>{__("settings.title")}</Title>
                <Button title={""} onClick={() => historyObject.goBack()} type={"square"} icon={"arrow-left"} />
            </div>
            <div className="content">
                <Tabber>
                    <TabberChild title={__("settings.tabs.account.title")}>
                        <SettingsAccount />
                    </TabberChild>
                    <TabberChild title={__("settings.tabs.payment.title")}>
                        <SettingsPayment />
                    </TabberChild>
                    <TabberChild title={__("settings.tabs.settings.title")}>
                        <SettingsEmail />
                    </TabberChild>
                </Tabber>
            </div>
        </div>
    </LoggedInLayout>
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingsPage);